import React from "react";
type ConfirmPopUpProps = {
  onClose: () => void;
  onConfirm?: () => void;
};

const ConfirmPopUp: React.FC<ConfirmPopUpProps> = ({ onClose, onConfirm }) => {
  return (
    <div
      className="modal fade show d-block custom-modal"
      tabIndex={-1}
      role="dialog"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content custom-modal-content">
          {/* Close Button */}
          <button className="custom-close" onClick={onClose}>
            <i className="fa-solid fa-xmark"></i>
          </button>

          <div className="modal-body text-center">
            <h5 className="fw-semibold mb-2">
              Are you sure you want to update this section?
            </h5>

            {/* <p className="text-muted small mb-4">
              You will not be able to recover the information once deleted!
            </p> */}

            {/* Buttons */}
            <div className="d-flex justify-content-center align-items-center gap-4">
              <button className="btn confirm-btn px-4" onClick={onConfirm}>
                Yes
              </button>
              <button className="btn text-dark cancel-btn" onClick={onClose}>
                No
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmPopUp;
